import React from "react"
import {connect} from "react-redux"

export const JobTypeDescription = connect(function mapStateToProps(state, ownProps) {
  const {selectedJobType, jobTypesById} = state.manageTool;
  return { selectedJobType, jobTypesById, ...ownProps }
})(({
      selectedJobType, jobTypesById
    }) => {
  const jobType = jobTypesById[selectedJobType];
  return <div>{
    jobType && <div>
      <h4>{selectedJobType}</h4>
      <em style={{whiteSpace: 'pre-line'}}>{jobType.description}</em>
      <hr />
    </div>
  }</div>
});
